/* Ruta Idiomas — interacciones (vanilla JS, sin librerías) */
(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.ri-reveal');
    if (!els.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ri-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ri-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initGallery() {
    document.querySelectorAll('[data-ri-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-ri-main]');
      if (!main) return;
      gallery.querySelectorAll('[data-ri-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          main.src = btn.getAttribute('data-src');
          main.alt = btn.getAttribute('data-alt') || '';
          gallery.querySelectorAll('[data-ri-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });
    });
  }

  function initVariants() {
    document.querySelectorAll('[data-ri-product]').forEach(function (root) {
      var dataEl = root.querySelector('[data-ri-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var selects = root.querySelectorAll('[data-ri-option]');
      var idInput = root.querySelector('input[name="id"]');
      var priceEl = root.querySelector('[data-ri-price]');
      var oldEl = root.querySelector('[data-ri-old-price]');
      var btn = root.querySelector('[data-ri-add]');
      var format = root.getAttribute('data-money-format') || '{{amount_with_comma_separator}} €';

      function money(cents) {
        var n = (cents / 100).toFixed(2);
        var withComma = n.replace('.', ',');
        return format
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
          .replace(/\{\{\s*amount\s*\}\}/, n)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100));
      }

      function update() {
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        });
        if (!match) {
          if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-unavailable'); }
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (oldEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            oldEl.textContent = money(match.compare_at_price);
            oldEl.hidden = false;
          } else {
            oldEl.hidden = true;
          }
        }
        if (btn) {
          btn.disabled = !match.available;
          btn.textContent = match.available ? btn.getAttribute('data-available') : btn.getAttribute('data-soldout');
        }
      }
      selects.forEach(function (s) { s.addEventListener('change', update); });
    });
  }

  function init() {
    initReveal();
    initGallery();
    initVariants();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
